import React from 'react';
import { useCart } from '../contexts/CartContext';
import { ShoppingCart } from 'lucide-react';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const hidePrice = !!product.omit_price;
  const hasDiscount =
    !hidePrice &&
    product.promo_price &&
    product.price != null &&
    product.promo_price < product.price;

  const displayPrice = hasDiscount ? product.promo_price : product.price;

  const mainImage =
    product.images && product.images.length > 0
      ? product.images[0].image_url
      : 'https://images.unsplash.com/photo-1588345921523-c2dcdb7f1dcd?w=400';

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast.success('Produto adicionado ao carrinho!', {
      duration: 2000,
    });
  };

  return (
    <a
      href={`/produto/${product.slug}`}
      className="product-card group cursor-pointer"
      data-testid={`product-card-${product.slug}`}
    >
      {hasDiscount && (
        <span className="badge-sale" data-testid="sale-badge">
          Promoção
        </span>
      )}

      {product.is_featured && (
        <span className="badge-featured" data-testid="featured-badge">
          Destaque
        </span>
      )}

      <div className="aspect-square overflow-hidden bg-slate-100">
        <img
          src={mainImage}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          data-testid="product-image"
        />
      </div>

      <div className="p-4">
        <h3
          className="font-semibold text-slate-800 mb-2 line-clamp-2"
          data-testid="product-name"
        >
          {product.name}
        </h3>

        {product.reference && (
          <p className="text-sm text-slate-500 mb-2" data-testid="product-reference">
            Ref: {product.reference}
          </p>
        )}

        <div className="mb-4 min-h-[56px] flex flex-col justify-center">
          {hidePrice ? (
            <span
              className="text-sm font-semibold leading-5"
              style={{ color: '#273e82' }}
              data-testid="product-price-hidden"
            >
              Adicione ao carrinho e consulte o preço
            </span>
          ) : (
            <div className="flex items-baseline gap-2">
              {hasDiscount && (
                <span
                  className="text-sm text-slate-400 line-through"
                  data-testid="original-price"
                >
                  R$ {Number(product.price).toFixed(2)}
                </span>
              )}
              <span
                className="text-xl font-bold"
                style={{ color: '#273e82' }}
                data-testid="product-price"
              >
                R$ {Number(displayPrice).toFixed(2)}
              </span>
            </div>
          )}
        </div>

        <button
          onClick={handleAddToCart}
          className="w-full flex items-center justify-center gap-2 font-bold py-3 px-4 rounded-lg transition-all"
          style={{
            backgroundColor: '#fef000',
            color: '#ffffff'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#273e82';
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#fef000';
            e.currentTarget.style.color = '#ffffff';
          }}
          data-testid="add-to-cart-button"
        >
          <ShoppingCart size={18} />
          Adicionar
        </button>
      </div>
    </a>
  );
};

export default ProductCard;